import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setUberDoc as updateUberDoc, setPayMethod as updatePayMethod, setPaid as updatePaid, reset } from '../redux/userSlice';
import { reset as insuranceReset } from '../redux/insuranceSlice';
import { reset as stripeReset } from '../redux/stripeSlice';
import { reset as portalReset } from '../redux/portalSlice';
import Question from "../components/Question";
import { Box, Typography, Link } from "@mui/material";
import pictionLogo from "../assets/piction-logo.png";
import uberdocLogo from "../assets/uberdoc-logo.png";
import integrationArrow from "../assets/integration-logo.png";
import ContinueButton from '../components/ContinueButton';
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export default function UberDocLanding() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(reset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
        dispatch(portalReset());
        dispatch(updateUberDoc(true));
        dispatch(updatePayMethod("self"));
        dispatch(updatePaid(true));
    }, [dispatch]);

    return (
        <Box sx={{ minHeight: '100vh', overflow: 'hidden' }}>
            <Question
                noBack={true}
                main={true}
                returning={false}
                landing={true}
                heading={
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                            margin: '16px 0'
                        }}>
                            <img
                                src={uberdocLogo}
                                alt="UberDoc Logo"
                                style={{
                                    width: '110px',
                                    height: '40px',
                                    objectFit: 'contain'
                                }}
                            />
                            <img
                                src={integrationArrow}
                                alt="Integration Arrow"
                                style={{
                                    width: '30px',
                                    height: 'auto'
                                }}
                            />
                            <img
                                src={pictionLogo}
                                alt="Logo of Piction Health"
                                style={{
                                    width: "110px",
                                    height: '40px',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </div>
                }
                title="Welcome to Piction Health!"
                subtitle={
                    <Typography variant="body1">
                        Our seamless process for getting care has two easy steps:
                        <br /><br />
                        1. Fill out this intake form, which will provide us with some important information.
                        <br />
                        2. One of our dermatologists will be assigned to review your case and provide a care plan within 48 hours.
                        <br /><br />
                        Ready? Let's go.
                    </Typography>
                }
                input={
                    <Box sx={{ pt: '3vh', zIndex: 9999, }}>
                        <ContinueButton
                            onClick={() => setPageAndDeferNavigate(dispatch, '/concern', navigate)}
                            title="Get Treatment"
                            selected={true}
                        />
                    </Box>
                }
            />
            <Box sx={{
                position: 'absolute',
                bottom: 35,
                left: 0,
                right: 0,
                px: 4,
                textAlign: 'center'
            }}>
                <Typography
                    sx={{
                        fontSize: '0.75rem',
                        color: 'text.secondary',
                        '& a': {
                            color: '#666666',
                            textDecoration: 'underline',
                            '&:hover': {
                                color: '#333333'
                            }
                        }
                    }}
                >
                    By continuing, you agree that you're 18 or older and to our{' '}
                    <Link href="https://www.pictionhealth.com/informed-consent" target="_blank" rel="noopener">
                        Patient Consent
                    </Link>
                    ,{' '}
                    <Link href="https://www.pictionhealth.com/npp" target="_blank" rel="noopener">
                        Notice of Privacy Practices
                    </Link>
                    ,{' '}
                    <Link href="https://www.pictionhealth.com/privacy-policy" target="_blank" rel="noopener">
                        Privacy Policy
                    </Link>
                    , and{' '}
                    <Link href="https://www.pictionhealth.com/terms-of-use" target="_blank" rel="noopener">
                        Terms
                    </Link>
                    . By providing your phone number, you consent to receiving appointment reminders & information via text message. You can always opt out of reminders by replying "stop".
                </Typography>
            </Box>
        </Box>
    );
}